export const ACCOUNT_STATEMENT_TEXTS = {
  tr: {
    accountStatementTitle: 'Hesap Ekstresi',
    downloadPdf: 'PDF / Dışa Aktar',
    loading: 'Hesap ekstresi yükleniyor...',
    noAccountSelected: 'Ekstre göstermek için bir personel veya cari seçin.',
    noStatementData: 'Bu hesaba ait hesap hareketi bulunamadı.',
    loadError: 'Hesap ekstresi yüklenemedi.',
    date: 'Tarih',
    transactionType: 'İşlem Tipi',
    debit: 'Borç',
    credit: 'Alacak',
    balance: 'Bakiye',
    movementDebit: 'Borç',
    movementCredit: 'Alacak',
    pdfDownloadError: 'PDF indirilemedi.',
    sectionSuffix: 'Ekstresi',
    summaryTitle: 'Özet Tablo',
    movementCount: 'hareket',
    openingBalance: 'Devir Bakiye',
    totalDebit: 'Toplam Borç',
    totalCredit: 'Toplam Alacak',
    netBalance: 'Net Bakiye',
    status: 'Durum',
    debtor: 'Borçlu',
    creditor: 'Alacaklı',
    balanced: 'Dengede',
    noSectionTransactions: 'İşlem bulunmamaktadır.'
  },
  en: {
    accountStatementTitle: 'Account Statement',
    downloadPdf: 'Download PDF',
    loading: 'Loading account statement...',
    noAccountSelected: 'Select a personnel or customer account to view the statement.',
    noStatementData: 'No account movements were found for this account.',
    loadError: 'Account statement could not be loaded.',
    date: 'Date',
    transactionType: 'Transaction Type',
    debit: 'Debit',
    credit: 'Credit',
    balance: 'Balance',
    movementDebit: 'Debit',
    movementCredit: 'Credit',
    pdfDownloadError: 'PDF could not be downloaded.',
    sectionSuffix: 'Statement',
    summaryTitle: 'Summary Table',
    movementCount: 'movements',
    openingBalance: 'Opening Balance',
    totalDebit: 'Total Debit',
    totalCredit: 'Total Credit',
    netBalance: 'Net Balance',
    status: 'Status',
    debtor: 'Debtor',
    creditor: 'Creditor',
    balanced: 'Balanced',
    noSectionTransactions: 'No transactions found.'
  },
  de: {
    accountStatementTitle: 'Kontoauszug',
    downloadPdf: 'PDF herunterladen',
    loading: 'Kontoauszug wird geladen...',
    noAccountSelected: 'Wählen Sie einen Personal- oder Kundenaccount aus.',
    noStatementData: 'Für dieses Konto wurden keine Bewegungen gefunden.',
    loadError: 'Kontoauszug konnte nicht geladen werden.',
    date: 'Datum',
    transactionType: 'Buchungstyp',
    debit: 'Soll',
    credit: 'Haben',
    balance: 'Saldo',
    movementDebit: 'Soll',
    movementCredit: 'Haben',
    pdfDownloadError: 'PDF konnte nicht heruntergeladen werden.',
    sectionSuffix: 'Auszug',
    summaryTitle: 'Zusammenfassung',
    movementCount: 'Bewegungen',
    openingBalance: 'Anfangssaldo',
    totalDebit: 'Gesamtsoll',
    totalCredit: 'Gesamthaben',
    netBalance: 'Nettosaldo',
    status: 'Status',
    debtor: 'Schuldner',
    creditor: 'Gläubiger',
    balanced: 'Ausgeglichen',
    noSectionTransactions: 'Keine Bewegungen vorhanden.'
  }
};

export const normalizeAccountStatementLanguage = (language = 'tr') => {
  const normalized = String(language || 'tr').trim().toLowerCase();

  if (normalized.startsWith('en')) return 'en';
  if (normalized.startsWith('de')) return 'de';
  return 'tr';
};

export const getAccountStatementTexts = (language = 'tr') => (
  ACCOUNT_STATEMENT_TEXTS[normalizeAccountStatementLanguage(language)] || ACCOUNT_STATEMENT_TEXTS.tr
);
